/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { linkShortenerCheck } from '../fn/link-shortener/link-shortener-check';
import { LinkShortenerCheck$Params } from '../fn/link-shortener/link-shortener-check';
import { linkShortenerCreate } from '../fn/link-shortener/link-shortener-create';
import { LinkShortenerCreate$Params } from '../fn/link-shortener/link-shortener-create';
import { linkShortenerRedirect } from '../fn/link-shortener/link-shortener-redirect';
import { LinkShortenerRedirect$Params } from '../fn/link-shortener/link-shortener-redirect';

@Injectable({ providedIn: 'root' })
export class LinkShortenerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `linkShortenerRedirect()` */
  static readonly LinkShortenerRedirectPath = '/link-shortener/{link}';

  /**
   * Redirect to SH by link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `linkShortenerRedirect()` instead.
   *
   * This method doesn't expect any request body.
   */
  linkShortenerRedirect$Response(params: LinkShortenerRedirect$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return linkShortenerRedirect(this.http, this.rootUrl, params, context);
  }

  /**
   * Redirect to SH by link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `linkShortenerRedirect$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  linkShortenerRedirect(params: LinkShortenerRedirect$Params, context?: HttpContext): Observable<void> {
    return this.linkShortenerRedirect$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `linkShortenerCreate()` */
  static readonly LinkShortenerCreatePath = '/link-shortener/{link}';

  /**
   * API to create new shortened link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `linkShortenerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  linkShortenerCreate$Response(params: LinkShortenerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return linkShortenerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * API to create new shortened link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `linkShortenerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  linkShortenerCreate(params: LinkShortenerCreate$Params, context?: HttpContext): Observable<void> {
    return this.linkShortenerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `linkShortenerCheck()` */
  static readonly LinkShortenerCheckPath = '/link-shortener/check/{link}';

  /**
   * API to check if shortened link is already claimed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `linkShortenerCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  linkShortenerCheck$Response(params: LinkShortenerCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return linkShortenerCheck(this.http, this.rootUrl, params, context);
  }

  /**
   * API to check if shortened link is already claimed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `linkShortenerCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  linkShortenerCheck(params: LinkShortenerCheck$Params, context?: HttpContext): Observable<void> {
    return this.linkShortenerCheck$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
